/**
 * Destination de retour après connexion ou inscription.
 *
 * ⚠ N'accepte QU'un chemin interne. Une valeur venue de l'URL et repassée
 * telle quelle à `router.push` est une redirection ouverte : `//exemple.com`
 * et `https://exemple.com` sont des destinations EXTERNES, et une page de
 * connexion qui y renvoie après authentification est un tremplin
 * d'hameçonnage — la victime vient de taper son mot de passe, elle fait
 * confiance à ce qui suit.
 *
 * On exige donc un `/` initial suivi d'autre chose qu'un second `/` ou qu'un
 * antislash (que certains navigateurs normalisent en `/`).
 */
export function destinationSure(brut: string | null, defaut = "/dashboard"): string {
  if (!brut) return defaut;
  if (!brut.startsWith("/")) return defaut;
  if (brut.startsWith("//") || brut.startsWith("/\\")) return defaut;
  return brut;
}
